import React, { useState } from "react";
import { useQuery } from "@tanstack/react-query";
import { History } from "lucide-react";
import api from "../lib/api";
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogDescription } from "./ui/dialog";
import { StoricoFiltrabile, oraDi } from "./StoricoFiltrabile";
import { useAuth } from "../context/AuthContext";

const EXTRA = {
  "cartella-clinica": ["visite_mediche", "visite_mediche_file", "visite_mediche_evento", "visite"],
  "impostazione-terapie": ["terapia_versioni", "terapie", "checklist_terapia", "terapie_checklist", "ospiti_glicemia_controlli"],
  terapie: ["terapie", "terapia_versioni", "checklist_terapia", "terapie_checklist", "somministrazioni"],
  "controllo-terapie": ["terapie", "controllo_terapie", "somministrazioni"],
  infettive: ["infettive", "infettive_terapie", "infettive_temp", "infettive_casi", "infettive_file", "infettive_register", "infettive_terapia", "evento_consegna", "visite_mediche_evento"],
  "check-list-sanitaria": ["checklist_sanitaria_item", "checklist_sanitaria_esec", "checklist_terapia", "infettive_checklist", "terapie_checklist"],
  movimenti: ["uscite", "ospedale", "movimenti"],
  utenti: ["utenti", "users"],
  buste_paga: ["buste_paga", "buste"],
  "menu-pasti": ["menu", "menu_pasti"],
  "programma-spesa": ["programma_spesa", "spesa"],
};
export const sezioniDi = (path) => {
  const seg = path.split("/").filter(Boolean)[0] || "";
  const u = seg.replace(/-/g, "_");
  return [...new Set([seg, u, ...(EXTRA[seg] || [])])].filter(Boolean);
};

function Riga({ r }) {
  return (
    <div className="py-2 text-sm" data-testid={`sm-riga-${r.id}`}>
      <div className="flex flex-wrap items-center gap-2"><span className="text-xs font-bold text-slate-500 w-11">{oraDi(r.at)}</span><span className="font-semibold">{r.frase}</span><span className="text-[11px] text-slate-500">da <b>{r.operatore || "\u2014"}</b>{r.via_pin ? " (PIN)" : ""}{r.device ? ` \u00b7 ${r.device}` : ""}</span></div>
      {(r.prima || r.dopo) && <div className="ml-12 mt-1 grid md:grid-cols-2 gap-1.5 text-[11px]">{r.prima && <div className="rounded border border-red-100 bg-red-50/60 px-2 py-1"><b className="text-red-700">Prima:</b> {r.prima}</div>}{r.dopo && <div className="rounded border border-emerald-100 bg-emerald-50/60 px-2 py-1"><b className="text-emerald-700">{r.prima ? "Dopo" : "Dati"}:</b> {r.dopo}</div>}</div>}
    </div>
  );
}

export function StoricoModificheBtn({ path, sezione, titolo }) {
  const { can } = useAuth();
  const [open, setOpen] = useState(false);
  const sez = sezioniDi(path);
  const { data = [], isLoading, error } = useQuery({ queryKey: ["storico-modifiche", path], enabled: open, queryFn: async () => (await api.get("/storico-modifiche", { params: { sezioni: sez.join(","), sezione } })).data });
  if (!(can("attivita") || can("audit")) || path === "/" || ["/attivita", "/audit"].includes(path)) return null;
  return <>
    <button type="button" onClick={() => setOpen(true)} className="p-2.5 rounded-lg hover:bg-secondary shrink-0" title="Storico modifiche di questa pagina" data-testid="header-storico-modifiche"><History size={20} /></button>
    {open && <Dialog open onOpenChange={setOpen}>
      <DialogContent className="max-w-5xl max-h-[90vh] overflow-y-auto" data-testid="storico-modifiche-dialog">
        <DialogHeader><DialogTitle>Storico modifiche · {titolo || "questa pagina"}</DialogTitle><DialogDescription className="text-xs">Chi ha creato, modificato o eliminato qualcosa in questa pagina, con data, ora e dettagli. Non si può cancellare. Tutto insieme lo trovi in «Attività operatori».</DialogDescription></DialogHeader>
        {isLoading ? <p className="text-sm text-muted-foreground">Caricamento…</p> : error ? <p className="text-sm text-red-700">{error?.response?.data?.detail || "Errore nel caricamento"}</p>
          : <StoricoFiltrabile generico rows={data} titolo={`Storico modifiche \u00b7 ${titolo || ""}`} nomeFile={`storico-${(path.split("/")[1] || "pagina")}`} renderRow={(r) => <Riga key={r.id} r={r} />} />}
      </DialogContent>
    </Dialog>}
  </>;
}
